export const precisionRound = (value: number, precision: number = 2) => {
  var factor = Math.pow(10, precision)
  return Math.round(value * factor) / factor
}

export const countDecimals = (value: number) => {
  let text = value.toString()
  // verify if number 0.000005 is represented as "5e-6"
  if (text.indexOf('e-') > -1) {
    return parseInt(text.split('e-')[1], 10)
  }
  // count decimals for number in representation like "0.123456"
  if (Math.floor(value) !== value) {
    return value.toString().split('.')[1].length || 0
  }
  return 0
}
